import { Combobox, Option } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { SortHelper } from "../../SortHelper";
import { Project } from "../../store/Data";
import { useEditorStyles } from "../Styles/Editor";

type ProjectDropdownProps = {
    setProject: (project?: Project) => void;
    currentProject?: Project;
    projects: Project[];
    ariaInvalid?: boolean;
    disabled?: boolean
};

export const ProjectDropdown: React.FC<ProjectDropdownProps> = ({ setProject, currentProject, projects, ariaInvalid, disabled }) => {
    // Filters
    const [Filter, setFilter] = React.useState<Project[]>([]);
    const [Search, setSearch] = React.useState<string | undefined>();
    // Other
    const { t } = useTranslation();
    const styles = useEditorStyles();
    // Initial load
    React.useEffect(() => {
        setFilter(projects);
    }, [projects]);
    return <Combobox
        className={styles.fluid}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        freeform
        placeholder={t('SelectProject')}
        onChange={(event) => {
            const value = event.target.value.trim();
            const matches = projects.filter(
                (c) => (c.displayName !== null && c.displayName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
            );
            setFilter(matches);
            if (value.length && matches.length < 1) {
                setSearch(value);
                setProject(undefined);
            } else if (value.length && matches.length === 1) {
                setSearch(value);
                setProject(matches[0]);
            } else {
                setSearch(undefined);
                setProject(undefined);
            }
        }}
        onOptionSelect={(event, data) => {
            if (data.optionValue) {
                const matchingOption = projects.find(c => c.projectid === data.optionValue);
                if (matchingOption) {
                    setSearch(undefined);
                    if (matchingOption.projectid !== currentProject?.projectid) {
                        setProject(matchingOption);
                    }
                    setFilter(projects);
                } else {
                    setSearch(data.optionText);
                }
            }
        }}
        defaultValue={currentProject && currentProject.displayName ? currentProject.displayName : undefined}
        defaultSelectedOptions={currentProject && currentProject.projectid ? [currentProject.projectid] : undefined}
        aria-invalid={ariaInvalid}
        disabled={disabled}
    >
        {Search ? (
            <Option key="freeform" text={Search}>
                Search for "{Search}"
            </Option>
        ) : null}
        {Filter.sort(SortHelper.ProjectByName).map((p) => (
            <Option key={p.projectid} value={p.projectid !== null ? p.projectid : ""}>{p.displayName !== null ? p.displayName : "-- ? --"}</Option>
        ))}
    </Combobox>;
};